import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ConfigModule } from 'Angular/config/config.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { ScatterPlotModule } from 'ChartApp/ts/features/scatter-plot/scatter-plot.module';
import { ComparablesModalButtonModule } from 'SecuritiesApp/ts/features/comparables-modal-button/comparables-modal-button.module';
import * as i0 from "@angular/core";
export class RiskInfoScatterPlotModule {
}
RiskInfoScatterPlotModule.ɵfac = function RiskInfoScatterPlotModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskInfoScatterPlotModule)(); };
RiskInfoScatterPlotModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RiskInfoScatterPlotModule });
RiskInfoScatterPlotModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        CommonModule,
        ComparablesModalButtonModule,
        ConfigModule,
        FormsModule,
        IconModule,
        ScatterPlotModule] });
